import React from 'react';
import { Button } from './ui/Button';
import { Check, ShieldCheck, FileText } from 'lucide-react';
export function PurchaseSection() {
  return <section id="compra" className="py-12 px-4 bg-blue-900 text-white relative overflow-hidden" data-id="element-252">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-253"></div>

      <div className="max-w-md mx-auto relative z-10" data-id="element-254">
        <div className="bg-white text-gray-900 rounded-3xl shadow-2xl overflow-hidden border-4 border-orange-500" data-id="element-255">
          {/* Product Image Section */}
          <div className="bg-gradient-to-b from-gray-50 to-white p-6" data-id="element-256">
            <img src="https://cdn.magicpatterns.com/uploads/9nrHgrHNZX2cKgxXVvQXXf/COVER_TDLO360.png" alt="Teoría de las Organizaciones 360" className="rounded-xl shadow-lg w-full" data-id="element-257" />
          </div>

          {/* Price Section */}
          <div className="px-6 py-8 text-center border-b border-gray-100" data-id="element-258">
            <p className="text-gray-400 text-sm font-semibold uppercase tracking-wider mb-2" data-id="element-259">
              Precio Final
            </p>
            <div className="mb-2" data-id="element-260">
              <span className="text-gray-400 text-2xl line-through" data-id="element-261">
                $49.990
              </span>
            </div>
            <div className="text-blue-900 font-black text-5xl mb-3" data-id="element-262">
              $19.990
            </div>
            <div className="inline-block bg-green-100 text-green-700 px-4 py-1 rounded-full text-sm font-bold" data-id="element-263">
              Ahorrás 60% HOY
            </div>
          </div>

          {/* Features Section */}
          <div className="px-6 py-6 space-y-4" data-id="element-264">
            {/* Feature 1 - Green */}
            <div className="bg-green-50 border border-green-200 rounded-xl p-4 flex gap-3" data-id="element-265">
              <div className="flex-shrink-0 mt-1" data-id="element-266">
                <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center" data-id="element-267">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-268" />
                </div>
              </div>
              <div data-id="element-269">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-270">
                  Sistema Completo TDLO 360
                </h4>
                <p className="text-sm text-gray-600" data-id="element-271">
                  Clases estructuradas para todo el año lectivo con ejemplos
                  argentinos actuales
                </p>
              </div>
            </div>

            {/* Feature 2 - Beige */}
            <div className="bg-orange-50 border border-orange-200 rounded-xl p-4 flex gap-3" data-id="element-272">
              <div className="flex-shrink-0 mt-1" data-id="element-273">
                <div className="w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center" data-id="element-274">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-275" />
                </div>
              </div>
              <div data-id="element-276">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-277">
                  2 Bonos Exclusivos (Gratis por hoy)
                </h4>
                <p className="text-sm text-gray-600" data-id="element-278">
                  Banco de actividades rápidas y pack completo de evaluaciones
                  listas
                </p>
              </div>
            </div>

            {/* Feature 3 - Blue */}
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 flex gap-3" data-id="element-279">
              <div className="flex-shrink-0 mt-1" data-id="element-280">
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center" data-id="element-281">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-282" />
                </div>
              </div>
              <div data-id="element-283">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-284">
                  Acceso Inmediato y Vitalicio
                </h4>
                <p className="text-sm text-gray-600" data-id="element-285">
                  Descargá todo el material al instante y accedé cuando lo
                  necesites, sin vencimiento
                </p>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="px-6 pb-6" data-id="element-286">
            <Button href="https://checkout.rincondigital.shop/cart/52931287646483:1" variant="primary" size="lg" fullWidth withArrow className="shadow-xl shadow-orange-500/30 text-lg py-5" data-id="element-287">
              ACCEDÉ AHORA Y EMPEZÁ A ENSEÑAR
            </Button>
          </div>

          {/* Trust Badges */}
          <div className="px-6 pb-6 flex items-center justify-center gap-6 text-sm text-gray-500" data-id="element-288">
            <div className="flex items-center gap-2" data-id="element-289">
              <ShieldCheck className="h-4 w-4 text-green-500" data-id="element-290" />
              <span data-id="element-291">Compra Segura</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-292">
              <FileText className="h-4 w-4 text-blue-500" data-id="element-293" />
              <span data-id="element-294">Material Digital</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}